<template>
  <div v-if="_visible" class="versionManage">
    <module-title :title="handleType == 'add'? '新增版本' : '编辑版本'">
      <div class="right">
        <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="back">
          返回
        </el-button>
      </div>
    </module-title>
    <el-form
      ref="addVersionForm"
      :model="addVersionForm"
      :rules="handleRules"
      label-position="right"
      label-width="120px"
    >
      <el-form-item label="应用名称：" prop="appName">
        <el-input
          v-model="appName"
          disabled
          name="name"
          :maxlength="50"
          placeholder=""
          class="handle-form-input"
        />
      </el-form-item>
      <el-form-item label="应用版本：" prop="editionNo">
        <el-input
          v-model="addVersionForm.editionNo"
          name="name"
          :maxlength="50"
          disabled
          placeholder="自动获取"
          class="handle-form-input"
        />
      </el-form-item>
      <el-form-item label="应用标签：">
        <el-input
          v-model="terminalName"
          disabled
          name="name"
          placeholder=""
          class="handle-form-input"
        />
      </el-form-item>
      <!-- <el-form-item label="关联应用选择：" prop="campusAppVersionIds" v-show="terminalId !=3 && terminalId !=4">
          <el-select
            v-model="addVersionForm.campusAppVersionIds"
            filterable
            class="handle-form-input"
            key="teacherApplication"
          >
            <el-option
              v-for="item in teacherAppUpgrades"
              :key="item.id"
              :label="`${item.appName} ${item.versionCode}  ${item.iterationNumber}`"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
      <div class="apk-box">
        <div class="teacher-apk">
          <!-- :required="true" -->
          <el-form-item label="版本类型：" label-width="100px" :required="true">
            <div :class="{'app-box':applyTerminals.indexOf('2')==-1}">
              <div v-if="applyTerminals && applyTerminals.indexOf('1')!=-1" style="margin-right:10px;margin-bottom:20px;">
                <span class="checkApplet">教师客户端</span>
                <el-select v-model="appTypeSelection.teacherType" clearable class="select-form-input" style="width:180px">
                  <el-option v-for="(item,index) in appTypeListHomeSchool" :key="index" :label="item.appName" :value="item.id" />
                </el-select>
                <span style="padding-left:10px;padding-right:10px">默认样式</span>
                <el-select v-model="addVersionForm.windowingStatus" style="width:100px" @change="changeWindowingStatus">
                  <el-option label="全屏" :value="0" />
                  <el-option label="窗口化" :value="1" />
                </el-select>
                <el-tooltip class="tip-icon" effect="dark" content="该应用在教师端打开后，默认展示的是全屏还是窗口化" placement="right" style="margin-left:10px;margin-right:20px;margin-top:12px">
                  <i class="el-icon-question" />
                </el-tooltip>
                <span style="padding-right:10px">是否支持窗口化</span>
                <el-select v-model="addVersionForm.supportWindowing" :disabled="addVersionForm.windowingStatus==1" style="width:100px">
                  <el-option label="是" :value="1" />
                  <el-option label="否" :value="0" />
                </el-select>
                <el-tooltip class="tip-icon" effect="dark" content="该应用在教师端打开后，是否支持窗口化的操作" placement="right" style="margin-left:10px;margin-top:12px">
                  <i class="el-icon-question" />
                </el-tooltip>
              </div>
              <div class="app-box">
                <div v-if="applyTerminals.indexOf('2')!=-1" style="margin-bottom:20px;">
                  <span class="checkApplet">学生客户端</span>
                  <el-select v-model="appTypeSelection.studentType" clearable style="width:180px">
                    <el-option v-for="(item,index) in appTypeListHomeStudent" :key="index" :label="item.appName" :value="item.id" />
                  </el-select>
                </div>
                <div v-if="applyTerminals.indexOf('1')!=-1 || applyTerminals.indexOf('2')!=-1" style="display:inline-block;margin-left: 10px;">
                  <upload-file
                    :props="{serveCode:'small_app_file',
                             accept:'.zip',
                             packageCheck:true,
                             type:['application/vnd.android.package-archive']}"
                    :is-decompress="true"
                    :handle-type="handleType"
                    @uploadSucess="uploadSucessFn"
                    @fileUploading="fileUploadingFn"
                    @apkParser="apkParserFn"
                    @smallPackage="smallPackage"
                    @beforeUpload="beforeUploadFn"
                  >
                    <el-button
                      :loading="fileUploading"
                      size="small"
                      type="primary"
                      icon="el-icon-upload2"
                      :disabled="handleType == 'edit'"
                    >
                      {{ fileUploading?'上传文件中...':'上传zip' }}
                    </el-button>
                  </upload-file>
                </div>
              </div>
            </div>
            <div v-if="applyTerminals && applyTerminals.indexOf('3')!=-1" class="applet-box" style="margin-bottom:20px">
              <span class="checkApplet">教师小程序</span>
              <el-input v-model="appTypeSelection.teacherAppletEntryUrl" placeholder="请输入H5地址" class="handle-form-input" />
            </div>
            <div v-if="applyTerminals && applyTerminals.indexOf('4')!=-1" class="applet-box">
              <span class="checkApplet">家长小程序</span>
              <el-input v-model="appTypeSelection.parentAppletEntryUrl" placeholder="请输入H5地址" class="handle-form-input" />
              <span style="padding-left:10px;padding-right:10px">小程序默认样式</span>
              <el-select v-model="addVersionForm.appletScreenOrientation" style="width:100px">
                <el-option label="竖屏" :value="1" />
                <el-option label="横屏" :value="2" />
              </el-select>
              <el-tooltip class="tip-icon" effect="dark" content="该应用在家长微信小程序打开后，小程序打开是否支持横竖屏，默认展示竖屏" placement="right" style="margin-left:10px;margin-right:20px;margin-top:12px">
                <i class="el-icon-question" />
              </el-tooltip>
            </div>
            <!-- </el-checkbox-group> -->
            <!-- <el-select v-model="addVersionForm.packageType" class="handle-form-input">
                <el-option v-for="item in appTypeList" :key="item.id" :label="item.appName" :value="item.id"/>
              </el-select> -->
          </el-form-item>
          <el-form-item label="包名：" prop="packageName" label-width="80px">
            <el-input
              v-model="addVersionForm.packageName"
              placeholder="自动获取"
              name="packageName"
              class="handle-form-input"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item label="MD5值：" prop="md5value" label-width="80px">
            <el-input
              v-model="addVersionForm.md5value"
              placeholder="自动获取"
              name="md5value"
              class="handle-form-input"
              :disabled="true"
            />
          </el-form-item>
        </div>
      </div>
      <el-form-item label="更新说明：" prop="introduction">
        <el-input
          v-model="addVersionForm.introduction"
          type="textarea"
          :rows="6"
          placeholder="请输入用更新说明，建议不超过150个汉字！"
          class="handle-form-textarea"
          maxlength="150"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer footer-btn">
      <el-button size="medium" @click="back">
        取消
      </el-button>
      <el-button
        :loading="ajaxLoading"
        type="primary"
        size="medium"
        @click="handleAddVersion"
      >
        {{ ajaxLoading?'Loading':'确定' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { formatTimeToStr } from '@/utils/index';
import {
  addVersion,
  updateVersion,
  getVersions
} from '@/api/productOperation/wisdom/applicationList';
import JsZip from 'jszip';

import { mapGetters } from 'vuex';
export default {
  name: 'AddVersion',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    handleType: {
      type: String,
      required: true
    },
    appId: {
      type: String,
      required: true
    },
    appName: {
      type: String,
      required: true
    },
    terminalId: {
      type: Number,
      required: true
    },
    updateRow: {
      type: Object,
      required: false
    },
    applyTerminals: {
      type: Array,
      required: false
    }
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length > 150) {
        callback(new Error('应用简介不能大于150个汉字！'));
      } else if (value.length < 1) {
        callback(new Error('应用简介为必填项！'));
      } else {
        callback();
      }
    };
    return {
      // 所有控制显示隐藏变量
      hiddenVariable: {
        addVersionVisible: false // 学生详情
      },
      listLoading: false, // 表格刷新loading
      versionManage: [],
      ajaxLoading: false, //  表单提交loading
      dialogImageUrl: '',
      addVersionForm: {
        status: '1'
      },
      handleRules: {
        name: [
          { required: true, message: '应用名称不能为空', trigger: 'blur' }
        ],
        md5value: [
          { required: !!(this.applyTerminals.indexOf('1') !== -1 || this.applyTerminals.indexOf('2') !== -1), message: 'MD5不能为空', trigger: 'blur' }
        ],
        packageName: [
          { required: !!(this.applyTerminals.indexOf('1') !== -1 || this.applyTerminals.indexOf('2') !== -1), message: '包名不能为空', trigger: 'blur' }
        ],
        // packageType: [
        //   { required: true, message: '应用类型不能为空', trigger: 'change' }
        // ],
        introduction: [{ required: true, validator: validatePass, trigger: 'blur' }]
      },
      // 上传应用信息
      fileUploading: false,
      teacherAppUpgrades: [], // 教师应用列表
      appTypeSelection: {
        teacherType: '',
        studentType: '',
        teacherAppletEntryUrl: '',
        parentAppletEntryUrl: ''
      },
      checkList: []
    };
  },
  computed: {
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    formatTimeToStr() {
      return formatTimeToStr;
    },
    ...mapGetters(['currentProdeuctId', 'userInfo']),
    userCode() {
      return this.userInfo.roleVOList[0].createUserCode;
    },
    terminalName() {
      var name = '';
      switch (this.terminalId) {
        case 1:
          name = '联机应用';
          break;
        case 2:
          name = '教师应用';
          break;
        case 3:
          name = '学生应用';
          break;
        case 4:
          name = '家校应用';
          break;
      }
      return name;
    },
    appTypeList() {
      return [
        { appName: '教师端：exe   学生端：APK', id: '11' },
        { appName: '教师端：exe   学生端：H5', id: '12' },
        { appName: '教师端：H5    学生端：APK', id: '21' },
        { appName: '教师端：H5    学生端：H5', id: '22' }
      ];
    },
    appTypeListHomeSchool() {
      return [
        { appName: 'exe', id: '1' },
        { appName: 'H5文件', id: '2' }
      ];
    },
    appTypeListHomeStudent() {
      return [
        { appName: 'APK', id: '1' },
        { appName: 'H5文件', id: '2' }
      ];
    }
  },
  watch: {
    _visible(val) {
      if (this.handleType === 'edit') {
        this.addVersionForm = {
          md5value: this.updateRow.md5value,
          packageName: this.updateRow.packageName,
          editionNo: this.updateRow.editionNo,
          introduction: this.updateRow.introduction,
          packageType: this.updateRow.packageType,
          // status: '1', // 去掉必填后新增
          // managementId: this.appId, // 去掉必填后新增
          // versionType: '1',
          campusAppVersionIds: this.updateRow.appVersions && this.updateRow.appVersions.length > 0 && this.updateRow.appVersions[0].id,
          supportWindowing: this.updateRow.supportWindowing,
          windowingStatus: this.updateRow.windowingStatus,
          appletScreenOrientation: this.updateRow.appletScreenOrientation
        };
        let teaType = '';
        let stuType = '';
        if (this.applyTerminals.indexOf('1') !== -1) {
          teaType = this.updateRow.packageType.substr(0, 1);
        }
        if (this.applyTerminals.indexOf('2') !== -1) {
          stuType = this.updateRow.packageType.substr(1, 1);
        }
        this.appTypeSelection = {
          teacherType: teaType === '0' ? '' : teaType,
          studentType: stuType === '0' ? '' : stuType,
          teacherAppletEntryUrl: this.applyTerminals.indexOf('3') !== -1 ? this.updateRow.teacherAppletEntryUrl : '',
          parentAppletEntryUrl: this.applyTerminals.indexOf('4') !== -1 ? this.updateRow.parentAppletEntryUrl : ''
        };
      } else {
        this.addVersionForm = {
          introduction: '', // 升级描述
          packageName: '',
          smallVersion: [],
          md5value: '',
          address: '',
          fileSize: '',
          editionNo: '',
          status: '1', // 去掉必填后新增
          managementId: this.appId, // 去掉必填后新增
          versionType: '1',
          // packageType: '',
          campusAppVersionIds: '',
          supportWindowing: 0,
          windowingStatus: 0,
          appletScreenOrientation: 1
        };
        this.appTypeSelection = {
          teacherType: '',
          studentType: '',
          teacherAppletEntryUrl: '',
          parentAppletEntryUrl: ''
        };
      }
    }
  },
  mounted() {
    this.initForm();
  },
  methods: {
    changeWindowingStatus(e) {
      if (e === 1) {
        this.addVersionForm.supportWindowing = 1;
      }
    },
    tipsInfo() {
      this.$message.error('请选择应用类型！');
    },
    initForm() {
      getVersions({ codes: [33] + '' }).then((res) => {
        this.teacherAppUpgrades = res.data;
      });
    },
    cancel() {
      this._visible = false;
      this.$parent('openView');
    },
    uploadSucessFn(val) { // 大包
      const name = val.file.name.split('_');
      const packageName = name[0];
      const editionNo = name[2];
      const iterationNumber = name[3];
      this.addVersionForm.bigIterationCode = iterationNumber;
      this.addVersionForm.managementId = this.appId;
      this.addVersionForm.packageName = packageName;
      this.addVersionForm.versionType = '1';
      this.addVersionForm.status = '1';
      this.addVersionForm.editionNo = editionNo;
      this.addVersionForm.md5value = val.md5Value;
      this.addVersionForm.address = val.absolutePath;
      this.addVersionForm.fileSize = val.file.size.toString();
      this.addVersionForm.createUserCode = this.userCode;
      this.fileUploading = false;
    },

    fileUploadingFn(val) {
      this.addVersionForm.smallVersion = [];
      this.addVersionForm.md5value = '';
      this.addVersionForm.editionNo = '';
      this.addVersionForm.packageName = '';
      this.fileUploading = val;
    },
    smallParams(val, appType) { // 小包参数
      var smallVersionData = {};
      if (appType === 'apk') { // 如果小包是apk就解析
        const ApkParser = require('app-info-parser/src/apk');
        const parser = new ApkParser(val.file);
        parser.parse().then(result => {
          smallVersionData.smallIterationCode = result.versionCode.toString();
          smallVersionData.packageName = result.package;
          smallVersionData.editionNo = result.versionName;
        }).catch(err => {
          console.log('err ----> ', err);
          this.$notify.success({
            title: 'error',
            message: '上传出错，请检查安装包是否正确！',
            showClose: false,
            duration: 2000
          });
        });
      } else {
        smallVersionData.packageName = val.packageName;
        smallVersionData.editionNo = val.packageVersion;
        smallVersionData.smallIterationCode = val.iterationNumber;
        // smallVersionData.editionNo = val.packageVersion.replace(val.extension, '');
      }
      smallVersionData.managementId = this.appId;
      smallVersionData.versionType = '2';
      smallVersionData.status = '1';
      smallVersionData.md5value = val.md5value;
      smallVersionData.fileSize = val.size.toString();
      smallVersionData.extension = val.extension;
      let n = null;
      switch (val.extension.toLowerCase()) {
        case '.zip':n = 1; break;
        case '.hzip':n = 2; break;
        case '.apk':n = 1; break;
        case '.hapk':n = 2; break;
      }
      smallVersionData.packageType = n;
      smallVersionData.createUserCode = this.userCode;
      this.addVersionForm.smallVersion.push(smallVersionData);
    },
    smallPackage(val, appType) {
      if (appType === 'apk') {
        this.smallParams(val, appType); // 小包apk
      } else if (appType === 'zip') {
        this.smallParams(val); // 小包zip
      }
    },
    apkParserFn(val) {
      this.addVersionForm.fileSize = val.file.size;
      const ApkParser = require('app-info-parser/src/apk');
      const parser = new ApkParser(val.file);
      parser.parse().then(result => {
        this.uploadSucessFn({ ...result, ...val });
      }).catch(err => {
        console.log('err ----> ', err);
        this.$notify.success({
          title: 'error',
          message: '上传出错，请检查安装包是否正确！',
          showClose: false,
          duration: 2000
        });
      });
    },
    // 上传应用包名检查
    packageNameCheck(fileName) {
      var name = fileName.split('_');
      if (name.length !== 6) {
        return false;
      }
      const pattern = new RegExp(/^[\d\s\.*]+$/);
      if (!pattern.test(name[3]) || !pattern.test(name[4])) {
        return false;
      }
      return true;
    },
    async beforeUploadFn(file, callback) {
      // const validateFlag = this.validateAppType();
      // if (!validateFlag) {
      //   return;
      // }
      var msg = '';
      var flag = this.packageNameCheck(file.name);
      if (!flag) {
        return callback({ data: { flag: false, msg: '包名校验不正确，请重新上传!' }});
      }
      try {
        var new_zip = new JsZip();
        const zip = await new_zip.loadAsync(file.raw);
        // console.log(zip.files);
        const fileNames = [];
        for (const key of Object.keys(zip.files)) { // 判断是否是目录
          fileNames.push(key);
          if (!this.packageNameCheck(key)) {
            flag = false;
            msg = '包名校验不正确，请重新上传!';
            break;
          }
        }
        return callback({ data: { flag, msg }});
      } catch (error) {
        return callback({ data: { flag: false, msg: '请上传正确的zip包' }});
      }
    },
    validateAppType() {
      if ((this.applyTerminals.indexOf('1') !== -1 && !this.appTypeSelection.teacherType)) {
        this.$message.error('请选择教师客户端！');
        return false;
      } else if (this.applyTerminals.indexOf('2') !== -1 && !this.appTypeSelection.studentType) {
        this.$message.error('请选择学生客户端！');
        return false;
      } else if (this.applyTerminals.indexOf('3') !== -1 && !this.appTypeSelection.teacherAppletEntryUrl) {
        this.$message.error('教师微信小程序不能为空！');
        return false;
      } else if (this.applyTerminals.indexOf('4') !== -1 && !this.appTypeSelection.parentAppletEntryUrl) {
        this.$message.error('家长微信小程序不能为空！');
        return false;
      } else {
        return true;
      }
    },
    // 添加应用
    handleAddVersion() {
      const flag = this.validateAppType();
      if (!flag) {
        return;
      }
      this.$refs['addVersionForm'].validate(valid => {
        const teacherType = !this.appTypeSelection.teacherType ? '0' : this.appTypeSelection.teacherType;
        const studentType = !this.appTypeSelection.studentType ? '0' : this.appTypeSelection.studentType;
        if (valid) {
          this.ajaxLoading = true;
          if (this.handleType === 'add') {
            const campusAppVersionIds = this.addVersionForm.campusAppVersionIds ? [this.addVersionForm.campusAppVersionIds] : [];
            const data = {
              ...this.addVersionForm,
              campusAppVersionIds,
              packageType: teacherType + studentType,
              teacherAppletEntryUrl: this.appTypeSelection.teacherAppletEntryUrl,
              parentAppletEntryUrl: this.appTypeSelection.parentAppletEntryUrl,
              typeCode: 'C15',
              supportWindowing: this.addVersionForm.supportWindowing,
              windowingStatus: this.addVersionForm.windowingStatus,
              appletScreenOrientation: this.addVersionForm.appletScreenOrientation
            };
            addVersion(data)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '添加成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this._visible = false;
                this.$parent.openView();
                this.$parent.fetchversionManage();
              })
              .catch(err => {
                // this.$message({
                //   message: err.data.resultMessage,
                //   type: 'error'
                // });
                console.log(err);
                this.ajaxLoading = false;
              });
          } else {
            const data = {
              updateUserCode: this.userCode,
              introduction: this.addVersionForm.introduction,
              campusAppVersionIds: this.addVersionForm.campusAppVersionIds ? [this.addVersionForm.campusAppVersionIds] : [],
              packageType: teacherType + studentType,
              teacherAppletEntryUrl: this.appTypeSelection.teacherAppletEntryUrl,
              parentAppletEntryUrl: this.appTypeSelection.parentAppletEntryUrl,
              typeCode: 'C15',
              supportWindowing: this.addVersionForm.supportWindowing,
              windowingStatus: this.addVersionForm.windowingStatus,
              appletScreenOrientation: this.addVersionForm.appletScreenOrientation
            };
            updateVersion(this.updateRow.id, data)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '编辑成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this._visible = false;
                this.$parent.openView();
                this.$parent.fetchversionManage();
              })
              .catch(err => {
                // this.$message({
                //   message: err.data.resultMessage,
                //   type: 'error'
                // });
                console.log(err);
                this.ajaxLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 返回
    back() {
      // true 提示， false直接返回
      // if (this.handleType !== 'add') {
      //   this._visible = false;
      //   return;
      // }
      const flag = Object.values(this.addVersionForm).some((item) => {
        return item.length > 0;
      });
      if (!flag) {
        this._visible = false;
        this.$parent.openView();
      } else {
        this.$confirm('您已输入部分内容，是否确认返回?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this._visible = false;
            this.$parent.openView();
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消返回!'
            });
          });
      }
      // this._visible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.versionManage {
  padding-bottom: 20px;
}
.handle-form-input {
  width: 300px;
}
.handle-form-textarea {
  width: 400px;
}
.eidt-pictures {
  float: left;
  .eidt-pictures-item {
    display: inline-block;
    position: relative;
    img {
      width: 148px;
      height: 148px;
      margin-right: 10px;
      border-radius: 6px;
      cursor: pointer;
    }
    .el-icon-error {
      position: absolute;
      top: 0;
      right: 10px;
      cursor: pointer;
      font-size: 16px;
      color: #f56c6c;
    }
  }
}
.el-upload-picture {
  float: left;
}
.footer-btn{
  margin-left: 200px;
}
.apk-box{
  display: flex;
  margin-left: 120px;
  margin-bottom: 20px;
}
.teacher-apk{
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  .app-box{
    display: flex;
    justify-content: space-between;
    .select-box{
      width: 35%;
      .select-form-input{
        width: 40%;
        // margin-left: 10px;
      }
    }
  }
  .type-box{
      padding-right: 10px;
    }
    .checkApplet{
      margin-right: 10px;
    }
  // .applet-box{
    // margin-top: 20px;
  // }
}
.student-apk{
  padding: 12px;
  margin-left: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
}
.styleInfo{
  margin-left: 20px;
  display: flex;
}
</style>
